<template>
  <div class="container">
    <div class="row">
      <div id="map" ref="googleMap"></div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h4>Speeds</h4>
        <canvas id="speedChart" height="150"></canvas>
      </div>
      <div class="col-md-6">
        <h4>Braking/Acceleration</h4>
        <canvas id="xaxisaccelerationChart" height="150"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { lineChart } from '../helpers/gofar-chart';

export default {
  name: "TripDetail",
  data() {
    return {
      tripdetails: [],
      flightPlanCoordinates: [],
      map: null,
    };
  },
  created() {
    
    
  },
  mounted() {
    this.fetchTripDetails();
    this.initializeMap();
  },
  methods: {
    async fetchTripDetails() {
      const result = await axios({
        method: "get",
        url: `https://api.gofar.co/api/trips/${this.$route.params.id}/tripdetails`,
        headers: {
          Authorization: localStorage.getItem("access_token"),
        },
      });
      this.tripdetails = result.data;
      const flightPlanCoordinates = result.data.filter((tripDetail)=> tripDetail.location).map((tripDetail) => tripDetail.location);
      const speeds = result.data.map((tripDetail) => tripDetail.speed);
      const xaxisaccelerations = result.data.map(
        (tripDetail) => tripDetail.xAxisAcceleration
      );
      const indexes = result.data.map((tripDetail) => tripDetail.index);
      const ctx = document.getElementById("speedChart");
      new lineChart(ctx, indexes, 'Speed', speeds);

      const ctx1 = document.getElementById("xaxisaccelerationChart");
      new lineChart(ctx1, indexes, 'X Axis Accelerations', xaxisaccelerations);

      const mapContainer = this.$refs.googleMap;
      const map = new google.maps.Map(mapContainer, {
        center: { ...flightPlanCoordinates[0] },
        zoom: 11,
      });
      const flightPath = new google.maps.Polyline({
        path: flightPlanCoordinates,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
      new google.maps.Marker({
        position: { ...flightPlanCoordinates[0]},
        map,
        title: "Started From",
      });
      new google.maps.Marker({
        position: { ...flightPlanCoordinates[flightPlanCoordinates.length - 1]},
        map,
        title: "Ended At",
      });
      flightPath.setMap(map);
    }
  },
};
</script>

<style scoped>
#map {
  height: 400px;
  width: 100%;
  /* The width is the width of the web page */
}
</style>
